import moment from "moment";
import { KeyValuePair } from "@shoothill/core";
import { AddStudentViewModel } from "../AddStudentViewModel";

export class DomainManager {
    constructor(private viewModel: AddStudentViewModel) {}

    public get studentOptions(): KeyValuePair[] {
        return this.viewModel.model.students.map((model: any) => ({
            key: model.id,
            text: `${model.firstName} ${model.lastName}`,
        }));
    }

    public get studentAddressOptions(): KeyValuePair[] {
        const student = this.viewModel.model.students.find((obj: any) => obj.id === this.viewModel.getValue("selectedStudentId"));
        if (!student) return [{ key: "noOption", text: "No Option" }];
        return student.studentAddresses.map((item: any) => ({
            key: item.id,
            text: item.addressTitle,
        }));
    }

    public get absenceShiftOptions(): KeyValuePair[] {
        return [
            { key: "1", text: "Morning" },
            { key: "2", text: "Afternoon" },
        ];
    }

    public get absenceTimeOptions(): KeyValuePair[] {
        return [
            { key: "1", text: "Lunch break " },
            { key: "2", text: "End of day" },
        ];
    }

    public get addButtonDisplayName(): string {
        return this.viewModel.managers.api.apiClient.IsBusy ? "Loading" : "Add";
    }

    /**
     * Converts an HH:mm:ss time string to a Date object for time picker display.
     * Returns a Date with the hours/minutes set from the string; date component is today.
     */
    public convertTimeToDate(value: any): Date {
        const updated = value ? value : "";
        const m = moment(updated, "HH:mm:ss");
        const d = new Date();
        d.setHours(m.hours());
        d.setMinutes(m.minutes());
        return d;
    }

    /**
     * Derives the session property key (e.g. "monAMStudentSessionId") from a start time and session key.
     * 12:00 is treated as AM; anything after 12:00 is PM — matching backend logic.
     */
    public buildSessionPropertyKey(startTime: string, sessionKey: string): string {
        const dayPrefix = sessionKey.replace(/(AM|PM)$/i, "");
        const time = moment(startTime, ["HH:mm", "HH:mm:ss"], true);
        const hours = time.isValid() ? time.hours() : 0;
        const minutes = time.isValid() ? time.minutes() : 0;
        const suffix = hours > 12 || (hours === 12 && minutes > 0) ? "PM" : "AM";
        return `${dayPrefix}${suffix}StudentSessionId`;
    }

    /**
     * Given a selected student and the current session key on the parent ViewModel,
     * returns the pre-filled start and end times from the student's timetable.
     */
    public getPreFilledTimesForStudent(studentId: string, sessionKey: string, studentList: any[]): { startTime: string; endTime: string } {
        const student = studentList.find((s: any) => s.studentId === studentId);
        if (!student) return { startTime: "", endTime: "" };

        const keyPrefix = sessionKey.slice(0, -2).toLowerCase();
        const entries = Object.entries(student).filter(([key]) => key.toLowerCase().includes(keyPrefix));

        return {
            startTime: (entries.find(([key]) => key.includes("startTime"))?.[1] as string) || "",
            endTime: (entries.find(([key]) => key.includes("endTime"))?.[1] as string) || "",
        };
    }
}
